/*
  ly-deferred-media.js
  Loads product card images in carousels only when they're about to be seen.

  Cards rendered with defer_media: true (see snippets/card-product.liquid) have
  data-srcset / data-src instead of srcset / src, so the browser doesn't fetch them.
  Lists marked [data-defer-media] (sections/featured-collection.liquid) are handled in
  two stages:
    1. Wait until the carousel is within one screen height of the viewport.
    2. Then load the slides that are visible or one carousel-width away, and the
       rest as the visitor swipes/scrolls the carousel towards them.
  If the list isn't a horizontal scroller (e.g. a plain grid), everything loads at
  stage 1. Without IntersectionObserver, everything loads straight away.
*/
(function () {
  var SELECTOR = 'img[data-srcset], img[data-src]';

  function load(img) {
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
      img.removeAttribute('data-srcset');
    }
    if (img.dataset.src) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    }
  }

  function loadAll(root) {
    root.querySelectorAll(SELECTOR).forEach(load);
  }

  function scrollsHorizontally(list) {
    var overflowX = getComputedStyle(list).overflowX;
    return (overflowX === 'auto' || overflowX === 'scroll') && list.scrollWidth > list.clientWidth + 1;
  }

  // Stage 2: load slides as they get within one carousel-width of view.
  function arm(list) {
    if (!scrollsHorizontally(list)) {
      loadAll(list);
      return;
    }
    var slideObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          slideObserver.unobserve(entry.target);
          loadAll(entry.target);
        });
      },
      { root: list, rootMargin: '0px 100% 0px 100%' }
    );
    list.querySelectorAll(SELECTOR).forEach(function (img) {
      slideObserver.observe(img.closest('li') || img);
    });
  }

  function init(scope) {
    var lists = (scope || document).querySelectorAll('[data-defer-media]');
    if (!lists.length) return;

    if (!('IntersectionObserver' in window)) {
      lists.forEach(loadAll);
      return;
    }

    // Stage 1: wait until the carousel is within one screen height of the viewport.
    var nearObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          nearObserver.unobserve(entry.target);
          arm(entry.target);
        });
      },
      { rootMargin: '100% 0px 100% 0px' }
    );
    lists.forEach(function (list) {
      if (list.dataset.deferMediaInit) return;
      list.dataset.deferMediaInit = 'true';
      nearObserver.observe(list);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor: sections re-render without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
